import React from 'react'
import './footer.css'
import { FiInstagram } from 'react-icons/fi'
import { IoLogoTwitter } from 'react-icons/io'

const footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>Dimension</a>
      <ul className="permalinks">
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.instagram.com/_.dimension._"><FiInstagram/></a>
        <a href="https://twitter.com/dimens_i_on"><IoLogoTwitter/></a>
      </div>

      <div className="footer__copyright">
        <small>Copyright © 2020 Dimension</small>
      </div>
    </footer>
  )
}

export default footer
